import Link from "next/link";
import { CategoryName, PageStatus } from "../category/[categoryName]/CategoryPage";
import { GLOBALS } from "config";
import { RankingIcon } from "app/components/Icons";

function continuePageHasWeekNav(categoryName: string) {
  return !!(
    (categoryName === "manga" && GLOBALS.HAS_MANGA_WEEK_NAV) ||
    (categoryName === "gravure" && GLOBALS.HAS_GRAVURE_WEEK_NAV) ||
    (categoryName === "column" && GLOBALS.HAS_COLUMN_WEEK_NAV)
  );
}

export function CategoryPageTabs({
  status,
  categoryName,
  day,
  inRankingPage,
}: {
  status: PageStatus;
  categoryName: CategoryName;
  day: number;
  inRankingPage?: boolean;
}) {
  return (
    <div className="g-tab-wrap">
      <nav className={"g-tab mode-" + categoryName}>
        <Link
          className={
            "g-tab-item" + (status === "continue" && !inRankingPage ? " mode-current" : "")
          }
          href={
            continuePageHasWeekNav(categoryName)
              ? `/category/${categoryName}/day/${day}/1`
              : `/category/${categoryName}/1`
          }
        >
          {categoryName === "gravure" && GLOBALS.IS_GRAVURE_TAB_ALL ? "すべて" : "連載"}
        </Link>
        {categoryName !== "gravure" && (
          <>
            <Link
              className={"g-tab-item" + (status === "oneShot" ? " mode-current" : "")}
              href={`/category/${categoryName}/oneShot/1`}
            >
              読み切り
            </Link>
            <Link
              className={"g-tab-item" + (status === "complete" ? " mode-current" : "")}
              href={`/category/${categoryName}/complete/1`}
            >
              完結
            </Link>
          </>
        )}
      </nav>
      <nav className="g-tab">
        <Link
          className={"g-tab-item" + (inRankingPage ? " mode-current" : "")}
          href={`/ranking/${categoryName}`}
        >
          <RankingIcon size={20} className="g-tab-item-icon mode-ranking" />
          <span className="g-tab-item-label mode-pc-only">ランキング</span>
        </Link>
      </nav>
    </div>
  );
}
